'use strict';

var React = require('react');
require('./email.scss');
var PageRoot = require('../../../components/page-root/page-root.jsx');
var EmailBody = require('../../../components/email/email-body.jsx');

var Email = React.createClass({
    render: function () {
        return (
            <section>
                <PageRoot>
                  <div className="background"></div>
                  <EmailBody />
                </PageRoot>
            </section>
        );
    }
});

module.exports = Email;



// WEBPACK FOOTER //
// ./src/client/pages/main/email/email.jsx